import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import YouTubeFilmGrid from './YouTubeFilmCard';

const FILMS = [
  {
    id: '5uzSqzTRa4Y',
    title: 'Aisha & Prez',
    subtitle: 'Wedding Film',
    description:
      'A heartfelt celebration of Aisha & Prez — the vows, the laughter and everyone they love, captured as a cinematic long-form wedding film.',
  },
  {
    id: 'rfEoZlTnQH8',
    title: 'Phil & Charlotte Bradford',
    subtitle: 'Wedding Film',
    description:
      "Phil & Charlotte's wedding celebration told in full — the quiet, tender moments and the big ones, woven into one romantic film.",
  },
];

export default function WeddingFilms() {
  const navigate = useNavigate();

  return (
    <section id="wedding-films" data-testid="wedding-films-root" className="relative bg-transparent">
      {/* Section intro band */}
      <div className="relative border-y border-white/10">
        <div className="px-6 md:px-14 py-10 md:py-14 flex flex-wrap items-baseline justify-between gap-6">
          <div className="flex items-center gap-4">
            <span className="text-[10px] md:text-xs uppercase tracking-[0.3em] text-[#D8FF3A] neon-text-glow">
              ◆ Wedding Films
            </span>
            <span className="hidden md:inline-block h-px w-12 bg-[#D8FF3A]/60" />
          </div>
          <motion.h2
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-white font-bold tracking-tight text-balance"
            style={{ fontSize: 'clamp(28px, 4vw, 56px)', lineHeight: 1 }}
          >
            Love, in long form.
          </motion.h2>
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-white/50">
            <span className="text-[#D8FF3A]">Full films</span> · YouTube
          </p>
        </div>
      </div>

      <div className="px-6 md:px-14 py-16 md:py-24">
        <div className="mx-auto max-w-6xl">
          <YouTubeFilmGrid items={FILMS} testidPrefix="wedding-film" />

          <div className="mt-14 md:mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-white/10 pt-10">
            <p className="text-sm md:text-base text-white/55 max-w-md">
              A taste of our wedding films. Explore the full catalogue — weddings, documentaries
              and events — in the portfolio.
            </p>
            <button
              data-testid="wedding-films-view-portfolio"
              onClick={() => {
                navigate('/portfolio');
                window.scrollTo(0, 0);
              }}
              className="group inline-flex items-center gap-3 bg-[#D8FF3A] text-black px-7 py-4 text-xs uppercase tracking-[0.25em] font-semibold hover:bg-white hover:neon-glow transition-all"
            >
              View full portfolio
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
